// Configuration for API endpoints and settings
const config = {
  // API Configuration
  api: {
    // Base URL for audiosum.app API (now comes from env variable)
    baseURL: process.env.REACT_APP_REVIEWS_API_URL || 'https://audiosum.app/api',
    
    // Request timeout in milliseconds
    timeout: parseInt(process.env.REACT_APP_API_REQUEST_TIMEOUT) || 10000,
    
    // Cache settings
    cache: {
      // Cache timeout in milliseconds (5 minutes)
      timeout: parseInt(process.env.REACT_APP_REVIEWS_CACHE_TIMEOUT) || 5 * 60 * 1000,
      
      // Enable/disable caching
      enabled: process.env.REACT_APP_ENABLE_REVIEWS_CACHE !== 'false'
    },
    
    // Polling settings
    polling: {
      // Polling interval in milliseconds (5 minutes)
      interval: parseInt(process.env.REACT_APP_REVIEWS_POLLING_INTERVAL) || 5 * 60 * 1000,
      
      // Enable/disable automatic polling
      enabled: process.env.REACT_APP_ENABLE_REVIEWS_POLLING !== 'false'
    },
    
    // Request configuration
    requestConfig: {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      mode: 'cors',
    }
  },
  
  // Reviews Display Configuration
  reviews: {
    // Default number of reviews to fetch
    defaultLimit: parseInt(process.env.REACT_APP_REVIEWS_DEFAULT_LIMIT) || 100,
    
    // Number of reviews to show initially (before "View More")
    initialDisplay: parseInt(process.env.REACT_APP_REVIEWS_INITIAL_DISPLAY) || 3,
    
    // Enable/disable fallback reviews when API fails
    enableFallback: true,
    
    // Animation and UI settings
    ui: {
      // Transition duration for expand/collapse
      transitionDuration: '0.5s',
      
      // Max height for collapsed state
      collapsedHeight: '400px',
      
      // Max height for expanded state
      expandedHeight: '800px',
      
      // Enable hover effects
      enableHoverEffects: true
    }
  },
  
  // Development/Testing Configuration
  development: {
    // Enable debug logging
    enableDebugLogging: process.env.REACT_APP_ENABLE_DEBUG_LOGGING === 'true' || process.env.NODE_ENV === 'development',
    
    // Use mock data instead of API
    useMockData: false,
    
    // Mock API delay (milliseconds)
    mockApiDelay: 1000
  }
};

export default config;